import { render, staticRenderFns } from "./BottomNavBar.vue?vue&type=template&id=28a8489a"
import script from "./BottomNavBar.vue?vue&type=script&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&lang=js"
import style0 from "./BottomNavBar.vue?vue&type=style&index=0&id=28a8489a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports